var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "yxtbiz-doc-player--picture",
    },
    [
      _c(
        "div",
        { staticClass: "yxtbiz-doc-player__container", style: _vm.width() },
        [
          _c(
            "div",
            {
              staticClass: "yxtbiz-doc-player__scroll",
              class: _vm.renderList.length === 1 ? "is-single" : "",
              on: { scroll: _vm.onScroll },
            },
            [
              _c(
                "div",
                {
                  staticClass: "yxtbiz-doc-player__wrapper",
                  style: _vm.wrapStyle,
                },
                _vm._l(_vm.renderList, function (item) {
                  return _c(
                    "div",
                    {
                      key: item._index,
                      staticClass: "yxtbiz-doc-player__content-item",
                      style: _vm.itemStyle(item),
                      attrs: { fit: "contain" },
                    },
                    [
                      item.url
                        ? _c("img", {
                            attrs: {
                              src: _vm.blobCache[item.url] || item.url,
                              width: "100%",
                              fit: "contain",
                            },
                          })
                        : _c("div", {
                            staticClass: "yxtbiz-doc-player__item-placeholder",
                          }),
                    ]
                  )
                }),
                0
              ),
            ]
          ),
          _vm._t("watermark"),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }